module.exports = __webpack_public_path__ + "static/media/P26.667fc803.jpg";